import { api } from './api/axiosInstance';
import { NOTIFICATION_LOGS } from './api/endpoints';
import { buildUrl } from './api/endpoints';

export const NotificationLogService = {
  getAll: (params) => api.get(buildUrl(NOTIFICATION_LOGS.ALL, params)),
  getStats: () => api.get(NOTIFICATION_LOGS.STATS),
};
